<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.fouls', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <EmptyState picture v-if="fouls.data.length === 0">
            <template v-slot:picture>
                <img src="/img/utils/undraw_blank_canvas_empty_state_positive.svg" alt="empty state" />
            </template>
        </EmptyState>
        <template v-else>
            <div class="md:hidden flex flex-col mt-5 divide-y divide-gray-200">
                <div v-for="(foul, index) in fouls.data" :key="index">
                    <div class="p-2 my-2" :class="index % 2 === 0 ? 'bg-gray-50' : 'bg-white'">
                        <div class="flex flex-wrap items-center justify-between">
                            <div class="text-gray-600">
                                <div>{{ foul.type_string }}</div>
                                <div v-if="foul.is_behaviour">
                                    {{ foul.severity_string }}
                                </div>
                            </div>
                            <div>
                                <p v-html="foul.public_description" />
                            </div>
                        </div>
                        <div class="flex flex-wrap items-center justify-between text-gray-600">
                            <div class="">
                                {{ foul.subject_name }}
                            </div>
                            <div>
                                {{ foul.date }}
                            </div>
                            <div>
                                {{ foul.turn }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="hidden md:flex flex-col mt-5">
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div
                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    >
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $tc('messages.subject', 1) }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.date') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.type') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.turn') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.description') }}
                                    </th>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        <span class="sr-only">{{ $t('messages.actions') }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    v-for="(foul, index) in fouls.data"
                                    :key="index"
                                >
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ foul.subject_name }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ foul.date }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        <div>{{ foul.type_string }}</div>
                                        <div v-if="foul.is_behaviour">
                                            {{ foul.severity_string }}
                                        </div>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ foul.turn }}
                                    </td>
                                    <td class="max-w-xs px-6 py-4 text-sm leading-5 text-gray-500">
                                        <p v-html="foul.public_description" />
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                    >
                                        <!--                                <InertiaSquareLinkButton action="show" :href="foul.links.show"/>-->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:pagination>
            <InertiaPagination :paginator="fouls" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import EmptyState from '@/components/EmptyState.vue';

export default {
    components: {
        PanelPage,
        InertiaPagination,
        EmptyState,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'fouls', 'filters'],
    data() {
        return {
            form: this.$inertia.form({
                search: this.filters.search,
            }),
        };
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
